import { createApp } from 'vue';
import WishlistSharePage from './wishlist-share-page.vue';
import commonStore from '../global/common-store';

export default () => {
  createApp(WishlistSharePage).use(commonStore).mount("vue-share-wishlist");
}